import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { ToastrModule } from 'ngx-toastr';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { CoronaComponent } from './pages/corona/corona.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { LoginRoutingModule } from './_pages/pages/auth/login/login-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '@visurel/iconify-angular';
import { QuillModule } from 'ngx-quill';
import { ImageDialogComponent } from './components/dialogs/image-dialog.component';
import { InfoDialogComponent } from './components/dialogs/info-dialog.component';
import { ConfirmPopup } from './components/dialogs/confirm-popup/confirm-popup.component';
import { CoronaNewTestDialogComponent } from './pages/corona/dialogs/corona-new-test-dialog.component';
import { CoronaNewAttendanceDialogComponent } from './pages/corona/dialogs/corona-new-attendance-dialog.component';
import { SignatureComponent } from './components/signature/signature.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MaterialModule } from './material.module';
import { MissingPermissionComponent } from './app.missing-auth.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { ShowdownModule } from 'ngx-showdown';
import { TeamsComponent } from './pages/teams/teams.component';
import { CustomerComponent } from './pages/customer/customer.component';
import { NewCustomerDialogComponent } from './pages/customer/dialogs/new-customer-dialog.component';
import { AppTranslateModule } from './app.translate.module';

import { SharedModule } from '@app/utilities/shared.module';

import { AppGlobalErrorhandler } from './services/error-handler.service';
import { TreeModule } from '@circlon/angular-tree-component';

import { LoaderComponent } from '@interceptors/loader/loader/loader.component';
import { LoaderInterceptor } from '@interceptors/loader/loader.interceptor';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ChangeCustomerDialogComponent } from '@app/pages/projects/dialogs/change-customer-dialog.component';
import { EditCustomerDialogComponent } from '@app/pages/customer/dialogs/edit-customer-dialog.component';

import { ImageCropperModule } from 'ngx-image-cropper';
import { SplashScreenComponent } from '@components/splash-screen/splash-screen.component';
import { PrimengModule } from '@app/primeng.module';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';
import { AuthConfigModule } from '@app/auth/auth-config.module';
import { LoginNotPossibleComponent } from '@app/pages/login-not-possible/login-not-possible';
import { TokenInterceptor } from '@app/auth/interceptores/token-interceptor';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

@NgModule({
    declarations: [
        AppComponent,
        SplashScreenComponent,
        DashboardComponent,
        CoronaComponent,
        CoronaNewTestDialogComponent,
        CoronaNewAttendanceDialogComponent,
        TeamsComponent,
        CustomerComponent,
        NewCustomerDialogComponent,
        ChangeCustomerDialogComponent,
        EditCustomerDialogComponent,
        ImageDialogComponent,
        InfoDialogComponent,
        SignatureComponent,
        SpinnerComponent,
        ConfirmPopup,
        LoaderComponent,
        MissingPermissionComponent,
        LoginNotPossibleComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        SharedModule,
        ImageCropperModule,
        ToastrModule.forRoot(),
        /*AuthenticationModule.forRoot({
			clientId: environment.idp.clientId,
			authority: environment.idp.authority,
			baseUrl: environment.idp.baseUrl,
			scopes: environment.idp.scopes,
			redirectUri: environment.redirectUrl,
			apiEndpoint: environment.baseUrl,
		}),*/

        // Vex
        VexModule,
        CustomLayoutModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: environment.production,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000',
        }),
        QuillModule.forRoot({
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    ['clean'],
                    // ['link', 'image']
                ],
            },
        }),

        CommonModule,
        IconModule,
        LoginRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
        PrimengModule,

        CKEditorModule,

        ShowdownModule.forRoot({
            flavor: 'github',
            tables: true,
            openLinksInNewWindow: true,
            encodeEmails: true,
        }),

        AppTranslateModule.forRoot(),
        TreeModule,
        AuthConfigModule,
    ],
    providers: [
        //{provide: MAT_DATE_LOCALE, useValue: 'de'},
        {
            provide: ErrorHandler,
            useClass: AppGlobalErrorhandler,
        },
        { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }, // spinner
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    ],
    bootstrap: [AppComponent],
})
export class AppModule {}
